import React from 'react'
import PropTypes from 'prop-types'
import { Field, Form } from 'react-final-form'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Login } from 'ra-ui-materialui'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslate, useLogin, useSafeSetState, useNotify } from 'react-admin'

const useStyles = makeStyles(
  (theme) => ({
    form: {
      padding: '0 1em 1em 1em',
    },
    input: {
      marginTop: '1em',
    },
    button: {
      width: '100%',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
  }),
  { name: 'RaLoginForm' }
)

const Input = ({
  meta: { touched, error }, // eslint-disable-line react/prop-types
  input: inputProps, // eslint-disable-line react/prop-types
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
)

const LoginForm = ({ redirectTo }) => {
  const [loading, setLoading] = useSafeSetState(false)
  const login = useLogin()
  const translate = useTranslate()
  const classes = useStyles({})
  const notify = useNotify()

  const validate = (values) => {
    const errors = { email: undefined, password: undefined }

    if (!values.email) {
      errors.email = translate('ra.validation.required')
    }
    if (!values.password) {
      errors.password = translate('ra.validation.required')
    }
    return errors
  }

  const submit = async (values) => {
    setLoading(true)
    try {
      await login(values, redirectTo)
    } catch (e) {
      notify(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Form
      onSubmit={submit}
      validate={validate}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <div className={classes.form}>
            <div className={classes.input}>
              <Field
                autoFocus
                type='text'
                id='email'
                name='email'
                component={Input}
                label='Email'
                disabled={loading}
              />
              <Field
                autoFocus
                type='password'
                id='password'
                name='password'
                component={Input}
                label='Password'
                disabled={loading}
              />
            </div>
          </div>
          <CardActions>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              disabled={loading}
              className={classes.button}
            >
              {loading && (
                <CircularProgress
                  className={classes.icon}
                  size={18}
                  thickness={2}
                />
              )}
              {translate('ra.auth.sign_in')}
            </Button>
          </CardActions>
        </form>
      )}
    />
  )
}

LoginForm.propTypes = { redirectTo: PropTypes.func.isRequired }

export default () => (
  <Login>
    <LoginForm />
  </Login>
)
